/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import RequireAuth from '@/commons/auth/RequireAuth'

import DaftarKelasPage from './containers/DaftarKelasPage'
import DetailKelasPage from './containers/DetailKelasPage'
import UbahKelasPage from './containers/UbahKelasPage'
import TambahKelasPage from './containers/TambahKelasPage'
import TambahJadwalKelasPage from './containers/TambahJadwalKelasPage'
import UbahJadwalKelasPage from './containers/UbahJadwalKelasPage'
import TambahDosenKelasPage from './containers/TambahDosenKelasPage'
import UbahDosenKelasPage from './containers/UbahDosenKelasPage'

const kelasRoutes = [
{ 
	path: "/kelas",
	element: <DaftarKelasPage />,
}

	
,
{ 
	path: "/kelas/ubah",
	element: <RequireAuth permissionNeeded="UpdateKelas" ><UbahKelasPage/></RequireAuth>
}

	
,
{ 
	path: "/kelas/tambah",
	element: <RequireAuth permissionNeeded="CreateKelas" ><TambahKelasPage/></RequireAuth>
}

	
,
{ 
	path: "/kelas/:kelasId/tambah-jadwal",
	element: <RequireAuth permissionNeeded="SaveJadwalKelas" ><TambahJadwalKelasPage/></RequireAuth>
}

	
,
{ 
	path: "/kelas/:kelasId/ubah-jadwal",
	element: <RequireAuth permissionNeeded="UpdateJadwalKelas" ><UbahJadwalKelasPage/></RequireAuth>
}

	
,
{ 
	path: "/kelas/:kelasId/tambah-dosen",
	element: <RequireAuth permissionNeeded="CreateKelasDosen" ><TambahDosenKelasPage/></RequireAuth>
}

	
,
{ 
	path: "/kelas/:kelasId/ubah-dosen",
	element: <RequireAuth permissionNeeded="UpdateKelasDosen" ><UbahDosenKelasPage/></RequireAuth>
}

	
,
{ 
	path: "/kelas/:id",
	element: <DetailKelasPage />,
}

	

]

export default kelasRoutes
